import { format } from 'date-fns';

export async function pushDatalayer(datalayer = {}) {
    let datalayerData = {
        ...datalayer
    }

    function generateSessionId() {
        return Math.random().toString(36).substr(2, 9) + '-' + Date.now();
    }

    if (datalayer.event === 'form' || datalayer.event === 'purchase_leadgen') {
        const company = await identifyCompany();

        if (company) {
            datalayerData = {
                ...datalayer,
                'company_name': company.company_name,
                'company_city': company.company_city,
                'coc_number': company.company_coc,
            };
        }
    }

    if (datalayer.event === 'page') {
        datalayerData = {
            ...datalayer,
            timestamp: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            environment: getEnvironment(),
            page_layout: window.matchMedia('(min-width: 992px)').matches ? 'desktop' : window.matchMedia('(min-width: 768px)').matches ? 'tablet' : 'mobile',
            platform: 'web',
            page_language: document.documentElement.lang,
        }
    }

    if (datalayer.event === 'page_404') {
        datalayerData = {
            ...datalayer,
            page404_url: window.location.href,
            page404_referrer: document.referrer,
        }
    }

    if (datalayer.event === 'user') {

        let sessionId = sessionStorage.getItem('session_id');
        if (!sessionId) {
            sessionId = generateSessionId();
            sessionStorage.setItem('session_id', sessionId);
        }

        const company = await identifyCompany();

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let clid, source;

        const click_ids = {
            'fbclid': 'facebook',
            'gclid': 'google',
            'twclid': 'twitter',
            'msclkid': 'microsoft',
            'li_fat_id': 'linkedin',
            'ttclid': 'tiktok',
            'scid': 'snapchat',
            'aff_click_id': 'affiliate',
            'aff_id': 'affiliate',
            'click_id': 'affiliate',
            'obclid': 'outbrain',
            'tbclid': 'taboola',
            'utm_id': 'custom',
            'trk_id': 'custom',
            'trk_clickid': 'custom',
            'campaign_id': 'custom',
            'pinid': 'pinterest',
            'amz_rtrk': 'amazon'
        };

        for (const property in click_ids) {
            if (queryString.includes(property)) {
                clid = urlParams.get(property);
                source = click_ids[property];
            }
        }

        datalayerData = {
            ...datalayer,
            'user_id': sessionId,
            'country_language': document.documentElement.lang,
            'source/medium': source,
            'clid': clid,
        };

        if (company) {
            datalayerData.company = company;
        }
    }

    if (Object.keys(datalayerData).length > 0) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(datalayerData);
    }
}

async function identifyCompany() {
    try {
        const data = await fetchLeadinfoData();

        if (!data?.name) {
            return null;
        }

        return {
            company_name: data.name,
            company_city: data.city,
            company_phone: data.phone,
            company_sic: data.branch_code_sic87,
            company_branch: data.branch_code,
            company_domain: data.domain,
            company_coc: data.coc_number,
        };
    } catch (error) {
        return null;
    }
}

async function fetchLeadinfoData() {
    const response = await fetch('https://api.leadinfo.com/v1/identify');

    if (!response.ok) {
        return null;
    }

    return response.json();
}

function getEnvironment() {
    const host = window.location.host;

    if (host.includes('qlico')) return 'dev';
    if (host.includes('acceptance')) return 'acc';
    if (host.includes('production')) return 'live';

    return 'live';
}
